import React, { useEffect, useState } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import SignIn from "../auth/SignIn";
import GateList from "../gates/GateList";
import UserList from "../users/UserList";
import UserDetails from "../users/UserDetails";
import GateDetails from "../gates/GateDetails";
import PrivateRoute from "../../PrivateRoute";
import { Switch, Link, useRouteMatch } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PeopleIcon from '@material-ui/icons/People';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import { fade, makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import clsx from 'clsx';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import { connect } from 'react-redux'
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { signOut } from '../../store/actions/authActions'
import { Result, Spin } from 'antd';

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
    },
    toolbar: {
      paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '0 8px',
      ...theme.mixins.toolbar,
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    menuButtonHidden: {
      display: 'none',
    },
    title: {
      flexGrow: 1,
    },
    drawerPaper: {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerPaperClose: {
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(9),
      },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      height: '100vh',
      overflow: 'auto',
    },
    container: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
    fixedHeight: {
      height: 240,
    },
    search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: fade(theme.palette.common.white, 0.15),
      '&:hover': {
        backgroundColor: fade(theme.palette.common.white, 0.25),
      },
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
      },
    },
    searchIcon: {
      padding: theme.spacing(0, 2),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    inputRoot: {
      color: 'inherit',
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        width: '12ch',
        '&:focus': {
          width: '20ch',
        },
      },
    }
  }));  

const drawerWidth = 240;

function Dashboard(props) {
    const [open, setOpen]         = useState(false);
    const [isAdmin, setAdmin]     = useState(false);
    const [isAdminLoading, setAdminLoading] = useState(true);
    // const [isLoading, setLoading] = useState(true);
    const handleDrawerOpen  = () => { setOpen(true); };
    const handleDrawerClose = () => { setOpen(false); };
    const classes = useStyles();
    const { auth } = props;
    let { path } = useRouteMatch();

    const logoff = () => {
      props.signOut()
    } 

    useEffect(() => {
      const CheckAdmin = async () => {
          let uid = props.auth.uid;
          if(typeof uid !== "undefined") {
            let results = await fetch(`https://us-central1-maximum-controls-app.cloudfunctions.net/api/v1/isAdmin/${uid}`)
              .then(result => result.json())
              .catch(e => {
                console.log("An error occur when trying to authenticate. Please refresh.")
              });
            if ( results.isAdmin === true) {
                setAdmin(true);
            }
            setAdminLoading(false);
          }
      }
      CheckAdmin();
    },[])

    return (auth.uid) ? 
        <div className={classes.root}>
            <CssBaseline />
            <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
                <Toolbar className={classes.toolbar}>
                    {isAdmin && 
                      <IconButton
                          edge="start"
                          color="inherit"
                          aria-label="open drawer"
                          onClick={handleDrawerOpen}
                          className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
                      >
                          <MenuIcon />
                      </IconButton>
                    }
                    <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                        Max Control
                    </Typography>
                </Toolbar>
            </AppBar>
            {isAdmin && 
              <Drawer
                  variant={window.innerWidth > 690 ? "permanent" : null}
                  classes={{
                      paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
                  }}
                  open={open}
                  id="navBar"
                  anchor={"left"}
              >
                  <div>
                      <div className={classes.toolbarIcon}>
                          <IconButton onClick={handleDrawerClose}>
                              <ChevronLeftIcon />
                          </IconButton>
                      </div>
                      <Divider />
                          <div>
                              {/* <ListItem button>
                              <ListItemIcon>
                                  <DashboardIcon />
                              </ListItemIcon>
                              <ListItemText primary="Dashboard" />
                              </ListItem> */}
                              <Link to="/admin/gates">
                                  <ListItem button>
                                      <ListItemIcon>
                                          <MeetingRoomIcon />
                                      </ListItemIcon>
                                      <ListItemText primary="Gates" />
                                  </ListItem>
                              </Link>
                              <Link to="/admin/users">
                                <ListItem button>
                                    <ListItemIcon>
                                        <PeopleIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Users" />
                                </ListItem>
                              </Link>
                          </div>
                      <Divider />
                  </div>
                  <div>
                      {/* <ListSubheader inset>Saved reports</ListSubheader> */}
                      <ListItem button onClick={() => logoff()}>
                          <ListItemIcon>
                              <ExitToAppIcon />
                          </ListItemIcon>
                          <ListItemText primary="Sign Out" />
                      </ListItem>
                  </div>
              </Drawer>
            }
            <main className={classes.content}>
                <div className={classes.appBarSpacer} />
                <Container maxWidth="lg" className={classes.container}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Paper className={classes.paper}>
                              
                                {isAdmin && 
                                  <Switch>
                                      <PrivateRoute path={path}               exact component={GateList}/>
                                      <PrivateRoute path={`${path}/gate/:id`} exact component={GateDetails}/>
                                      <PrivateRoute path={`${path}/(gates?)`} exact component={GateList}/>
                                      <PrivateRoute path='/admin/(users?)'    exact component={UserList}/>
                                      <PrivateRoute path='/admin/user/:id'    exact component={UserDetails}/>
                                      
                                  </Switch>
                                }
                                {isAdmin === false && isAdminLoading === false &&
                                  <Result
                                      status="warning"
                                      title="Admin Privileges Required"
                                      extra={
                                        <div>
                                          <span>This area is restricted to users</span>
                                          <br/>
                                          <br/>
                                          <button onClick={() => props.signOut()}>Sign Out</button>
                                        </div>}
                                  />
                                }
                                {isAdmin === false && isAdminLoading === true &&
                                  <Spin size="large" />
                                }
                            </Paper>
                        </Grid>
                    </Grid>
                    {/* <Box pt={4}>
                        <Copyright />
                    </Box> */}
                </Container>
            </main>
        </div>
    : <SignIn />
    
}

const mapDispatchToProps = (dispatch) => {
    return {
      signOut: () => dispatch(signOut())
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
        missions: state.missions
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
